import { Component } from '@angular/core';

declare var $:any;

@Component({
    selector: 'footer-cmp',
    templateUrl: 'footer.component.html'
})

export class FooterComponent{
    test : Date = new Date();
    public baseUrl: string;
    public brand: string;
    constructor() {
        this.baseUrl = window.location.host.split('.').splice(1).join('.');
        if (!this.baseUrl) {
            this.brand = "Mars By GHC";
        } else if (this.baseUrl == 'ghc.health') {
            this.brand = "Mars By GHC";
        } else if (this.baseUrl == 'saturn.health') {
            this.brand = "Saturn By GHC";
        } else {
            this.brand = "Mars By GHC";
        }
    }
}
